import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const createP2PReservationRequestAPI = async ({
    authToken,
    subsidiaryId,
    customerId,
    vehicleId,
    startDate,
    endDate,
    expectedKm = 0,
    initComment = "",
}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/p2p/${customerId}/reservation/create-request/${vehicleId}`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
    };

    const payload = {
        planned_start_date: startDate,
        planned_end_date: endDate,
        vehicleId,
        expected_kilometers: Number(expectedKm) || 0,
        init_comment: initComment,
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    if (response.status === 204) {
        return {};
    }

    return await response.json();
};

export {createP2PReservationRequestAPI};
